import { Cart } from "@commercetools/platform-sdk"
import { ScopeContext } from "@sentry/core"
import { TFunction } from "i18next"
import { ErrorType } from "../../../error/ErrorType"
import { CartValidationBase, cartSuccess } from "../../validation/FormValidator"
import {
  CartValidationResult,
  cartError
} from "../../validation/ValidationError"

export class CartOrderableValidation extends CartValidationBase {
  private readonly t: TFunction
  private readonly captureMessage: (
    message: string,
    captureContext?: Partial<ScopeContext>
  ) => void

  constructor(
    t: TFunction,
    captureMessage: (
      message: string,
      captureContext?: Partial<ScopeContext>
    ) => void
  ) {
    super("CartOrderableValidation")
    this.t = t
    this.captureMessage = captureMessage
  }

  validate(c: Cart): CartValidationResult {
    const cartState = c?.cartState
    if (cartState === "Ordered") {
      this.captureMessage(`Cart ${c?.id} has already been ordered`)
      return cartError(ErrorType.CartAlreadyOrderedError, {
        title: this.t("checkout:cartAlreadyOrdered"),
        message: this.t("checkout:cartAlreadyOrdered")
      })
    } else if (cartState !== "Active") {
      this.captureMessage(
        `Cart ${c?.id} is not active, currently in state: ${cartState}`
      )
      return cartError(ErrorType.CartValidationError, {
        title: this.t("checkout:cartInactive"),
        message: this.t("checkout:cartInactive", { state: cartState })
      })
    }
    return cartSuccess(c)
  }
}
